
import { appendALink } from "../components/alink";
import { renderLayout } from "../components/layout";
import { loadPacksOffline } from "../services/db";

export function initHelp() {
    
    const content = `
        <h3 class="ac">Help</h3>
        <div id="debug"></div>
        <div id="back-link"></div>
    `;
    renderLayout(content);

    const backLinksElement = document.getElementById("back-link") as HTMLElement;
    if(backLinksElement) {
        appendALink(backLinksElement, { href: "/dashboard", text: "Back to Dashboard" });
    }


    loadDebugInformation();

    async function loadDebugInformation(): Promise<void> {
        const packs = await loadPacksOffline();

        console.log("packs", packs);
        //var firstPackk = packs.get("2");


        const debugElement = document.getElementById("debug") as HTMLElement;

        debugElement.innerText = `Total packs: ${packs?.length}`;

    }


  
}